module.exports = __webpack_public_path__ + "f8ece8ae2b8ff188f24b9f4f4f483718.svg";